<template>
<!-- 整图样式 -->
  <div
    id="headerPic"
    class="headerPic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  >
    <div  class="title white">{{tb.title}}</div>
    <div  class="introduce white">{{tb.introduce}}</div>
    <div  class="tags-row">
      <span class="white">{{ tb.day?tb.day:'-' }}天{{ tb.night?tb.night:'-'}}晚</span>
      <span class="yellow price">{{ tb.numberMin }}人预估报价:{{ tb.price }}元/人</span>
    </div>
    <div @click="goQuote" class="link" v-if="!type">
      <span class="top">点击自主报价</span>
      <span class="bottom">解锁更多玩法</span>
    </div>
    <div class="planner white">策划师 &nbsp;&nbsp;|&nbsp;&nbsp;{{ tb.plannerName }}</div>
    <div  class="sn" v-if="tb.sn">编号:{{tb.sn}}</div>
  </div>
</template>

<script>
export default {
  name: "headerPic",
  data() {
    return {
      loading: false
    };
  },
  props: ["tb","backgroundPic","type"],
  methods: {
    // 跳转链接
    goQuote(){
      window.open("/#/teamBuildingQuote?tbId="+this.tb.id+"&title="+this.tb.title+"&numberMin="+this.tb.numberMin);
    },
    // 打开年会咨询
    // openMeeting(){
    //   this.$emit("openAnnualMeeting", false);
    // },
  },

  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
#headerPic {
  width: 100%;
  height: 100%;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
  position: relative;
}
.link{
  width: 100%;
  height: 100%;
  cursor: pointer;
}

#headerPic .title{
  position: absolute;
  font-size: 40px;
  color: #fff;
  bottom: 360px;
  left: 110px;
  right: 105px;
  /* right: 380px; */
}

#headerPic .introduce{
  position: absolute;
  font-size: 20px;
  color: #fff;
  top: 267px;
  left: 110px;
  right: 105px;
  /* right: 380px; */
}
#headerPic .tags-row{
  position: absolute;
  font-size: 20px;
  top: 415px;
  left: 110px;
}
#headerPic .price{
  margin-left: 20px;
}
#headerPic .yellow{
  color: #FFFF00;
}

#headerPic .white{
  color: #fff;
}

#headerPic .link{
  color: #1F6D77;
  background: #FFFF00;
  height: 60px;
  width: 160px;
  padding: 10px 30px;
  font-size: 21px;
  position: absolute;
  bottom: 55px;
  left: 110px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#headerPic .link .top{
  font-size: 26px;
  line-height: 40px;
  font-weight: 700;
}
#headerPic .link .bottom{
  font-size: 16px;
  line-height: 20px;
  font-weight: 0;
}

#headerPic .planner{
  position: absolute;
  top: 480px;
  right: 40px;
  font-weight: 700;
  font-size: 18px;

}

#headerPic .sn{
  position: absolute;
  top: 542px;
  right: 40px;
  font-size: 16px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/headerPic.vue